<template>
  <el-tabs type="border-card">
    <el-tab-pane :label="$t('gatewayDetail.gatewayInfo')">
      <el-col :span="12" style="border-right:1px #000000 dashed;">
        <el-form>{{$t('gatewayDetail.basicInfo')}}</el-form>
    <el-dialog
      :title="$t('gatewayDetail.checkAdimin')"
      :modal-append-to-body="false"
      :lock-scroll="false"
      :visible.sync="passwordVisible"
      width="320px"
      style="margin-top:10%"
    >
      <el-form class="demo-ruleForm" ref="adminPassForm">
        <el-form-item :label="$t('gatewayDetail.password')" prop="adminPass">
          <el-input
            v-model="adminPassForm.adminPass"
            :placeholder="$t('gatewayDetail.password')"
            maxlength="18"
          ></el-input>
        </el-form-item>
        <el-form-item
          style="display:flex;justify-content:center;align-items:center;"
        >
          <el-button type="primary" @click="confirmAdminpass()">{{$t('gatewayDetail.confirm')}}</el-button>
          <el-button type="primary" @click="passwordVisible = false"
            >{{$t('gatewayDetail.cancel')}}</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
        <el-form label-width="160px" class="demo-ruleForm">
          <el-form-item :label="$t('gatewayDetail.deviceName')" style="height:10px">{{this.$store.state.gatewayDetail.deviceName}}</el-form-item>
          <el-form-item :label="$t('gatewayDetail.number')" style="height:10px">{{this.$store.state.gatewayDetail.deviceId}}</el-form-item>
          <el-form-item :label="$t('gatewayDetail.onlineStatus')" style="height:10px">{{this.$store.state.gatewayDetail.isOnline==1?$t('gatewayDetail.online'):$t('gatewayDetail.offline')}}</el-form-item>
          <el-form-item :label="$t('gatewayDetail.bindTime')" style="height:10px">{{this.$util.formartDateTime(this.$store.state.gatewayDetail.bindTime)}}</el-form-item>
          <el-form-item :label="$t('gatewayDetail.bindInfo')" style="height:10px">{{this.$store.state.gatewayDetail.roomName}}{{$t('gatewayDetail.room1')}}</el-form-item>
          <el-form-item :label="$t('gatewayDetail.gatewayModel')" style="height:10px">{{this.$store.state.gatewayDetail.modelNo}}</el-form-item>
          <el-form-item :label="$t('gatewayDetail.softwareVersion')" style="height:10px">{{this.$store.state.gatewayDetail.enVersion}}</el-form-item>
          <el-form-item :label="$t('gatewayDetail.hardwareVersion')" style="height:10px">{{this.$store.state.gatewayDetail.hardwareVersion}}</el-form-item>
        </el-form>
      </el-col>
      <el-col :span="12" style="padding:3px">
            <el-col :span="24" style="height:30px">{{$t('gatewayDetail.ob')}}</el-col>
            <el-col :span="8" style="margin-top:5px">
              <div style="margin-left:10px">
                <el-button size="mini" @click="unbindGateway()">{{$t('gatewayDetail.unbind')}}</el-button>
              </div>
            </el-col>
            <el-col :span="8" style="margin-top:5px">
              <div style="margin-left:10px">
                <el-button size="mini" @click="unbindForceGateway">{{$t('gatewayDetail.forceUnbind')}}</el-button>
              </div>
            </el-col>
      </el-col>
    </el-tab-pane>
    <el-tab-pane :label="$t('gatewayDetail.relevance')">
        <el-table
        :data="bindDeviceData"
        :header-cell-style="{background:'#eef1f6',color:'#606266'}"
        empty-text="No Data"
        border
      >
        <el-table-column type="index" :label="$t('gatewayDetail.order')" width="70" align="center"></el-table-column>
        <el-table-column prop="roomName" :label="$t('gatewayDetail.room1')" align="center"></el-table-column>
        <el-table-column prop="deviceList" :label="$t('gatewayDetail.device')" align="center">
           <template slot-scope="scope">
             {{getGatewayDeviceList(scope.row)}}
           </template>  
        </el-table-column>
      </el-table>
    </el-tab-pane>

    <el-tab-pane :label="$t('gatewayDetail.aleamLog')">
       <el-table
        :data="alarmData"
        :header-cell-style="{background:'#eef1f6',color:'#606266'}"
        empty-text="No Data"
        border
      >
        <el-table-column type="index" :label="$t('gatewayDetail.order')" width="70" align="center"></el-table-column>
        <el-table-column prop="alarmMessage" :label="$t('gatewayDetail.aleamRemark')" align="center"></el-table-column>
        <el-table-column prop="alarmType" :label="$t('gatewayDetail.aleamType')" align="center"></el-table-column>
        <el-table-column prop="createTime" :label="$t('gatewayDetail.aleamTime')" :formatter="this.$util.datetimeFormat" align="center"></el-table-column>
        <el-table-column prop="deviceId" :label="$t('gatewayDetail.deviceId')" align="center">
        </el-table-column>
      </el-table>
      <Pagings
        :total="total"
        :offset="alarmPageData.offset"
        :pageSize="alarmPageData.pageNumber"
        @handleSizeChangeSub="alarmHandleSizeChange"
        @handleCurrentChangeSub="alarmHandleCurrentChange"
      ></Pagings>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import Pagings from "../common/Pagings.vue";
export default {
  name: "deviceDetail", //这个LoginName最好和引入的vue的LoginName相同
  props: ["infoData","roomData","tabIndex","sonTabsItem"],
  data() {
    return {
      alarmPageData: {
        offset: 1,
        pageNumber: 10
      },
      total: 1, //总条数
      alarmData:[],
      bindDeviceData:[],
      gatewayIsRemove:false,
      // lockDetail:[]
      deviceId: "",
      passwordVisible:false,
      adminPassForm: {
        adminPass: ""
      }
    };
  },
   watch: {
    tabIndex(val) {
      this.currTabIndex = val;
      var sonTabsItem = this.sonTabsItem;
      for (var str in sonTabsItem) {
        if (sonTabsItem[str].apartmentId == this.infoData.apartmentId) {
          var sonTabItemList = sonTabsItem[str].tabsItem;
          for (var s in sonTabItemList) {
            if (sonTabItemList[s].name == val &&val != 1 &&sonTabItemList[s].type==2) {//过滤网关类型
              this.deviceId = sonTabItemList[s].id;
              this.roomData=sonTabItemList[s].ref;
              this.$store.commit("getGatewayDetail", {deviceId:this.deviceId}); //加载网关详细
              this.bindDevice();
              this.alarmPower();
            }
          }
        }
      }
    },
    '$store.state.gatewayDetail': function () {
       var gatewayData=this.$store.state.gatewayDetail;
       if(typeof(gatewayData.deviceId)== "undefined"){
           this.$mainInfo.removeTab(this.tabIndex);
       }
      //你需要执行的代码
    }  
  },
  created() {
    // this.getGatewayDetail();
   
    var sonTabsItem = this.sonTabsItem;
    for (var str in sonTabsItem) {
      if (sonTabsItem[str].apartmentId == this.infoData.apartmentId) {
        var sonTabItemList = sonTabsItem[str].tabsItem;
        for (var s in sonTabItemList) {
          if (sonTabItemList[s].name == this.tabIndex && this.tabIndex != 1 &&sonTabItemList[s].type==2) {
               this.deviceId = sonTabItemList[s].id;
               this.roomData=sonTabItemList[s].ref;//得到设备ID
               this.$store.commit("getGatewayDetail", {deviceId:this.deviceId}); //加载网关详细
               this.bindDevice();
               this.alarmPower();
          }
        }
      }
    }
  },
  methods: {
    //强制解绑
    unbindForceGateway(){
        this.passwordVisible=true;
    },
    //确认管理密码
    confirmAdminpass(){
       var formData = new FormData();
        formData.append("deviceId", this.deviceId);
        formData.append("deviceType", 0); //设备类型：应用网关0，联网门锁1，离线门锁2，NB门锁3
        formData.append("isForceUnbind", 1);
        formData.append("password",this.adminPassForm.adminPass);
        this.$server
          .exam("/customer/apartment/unbindDevice", formData)
          .then(data => {
            if (data.code == 200) {
              var rtnData = data["data"];
              // this.passwordVisible=false;
              this.$message({
                message: data.message,
                type: "success"
              });
              this.$store.commit("getApartmentDetail", {
                apartmentId: this.infoData.apartmentId
              }); //加载公寓楼栋
               this.$mainInfo.removeTab(this.tabIndex);
            } else {
              this.$message({
                message: data.message,
                type: "warning"
              });
            }
          });
    },
    //解绑
    unbindGateway(){
      // this.$confirm('此操作将解绑网关绑定关系, 是否继续?', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
        var formData = new FormData();
         formData.append("deviceId", this.deviceId);
         formData.append("deviceType", 0);
         formData.append("isForceUnbind", 0);
        this.$server
        .exam("/customer/apartment/unbindDevice", formData)
        .then(data => {
          if (data.code == 200) {
            const loading = this.$loading({
              lock: true,
              text: "Loading",
              spinner: "el-icon-loading",
              background: "rgba(0, 0, 0, 0.7)"
            });
            var obj={};
            obj.apartmentId=this.infoData.apartmentId;
            obj.deviceId=this.roomData.deviceId;
            obj.roomId=this.roomData.roomId;
            obj.rId=data.data;
            obj.loading=loading;
            obj.opType="unbindGateway";
            obj.othis=this;
            obj.tabIndex=this.tabIndex
            this.$store.dispatch("checkResult",obj);//等待回调
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
         });
      //   }).catch(() => {
      //     this.$message({
      //       type: 'info',
      //       message: '已取消解除'
      //     });          
      // });
    },
    // getGatewayDetail() {
    //   var formData = new FormData();
    //   formData.append("deviceId", this.roomData.deviceId);
    //   this.$server
    //     .exam("/customer/apartment/getGatewayDetail", formData)
    //     .then(data => {
    //       if (data.code == 200) {
    //         this.lockDetail = data.data;
    //         // this.total = data.data.total;
    //         // this.oAssEquipmentDto.offset = 1;
    //         // this.oAssEquipmentDto.pageNumber = data.data.pages;
    //       } else {
    //         this.$message({
    //           message: data.message,
    //           type: "warning"
    //         });
    //       }
    //     });
    // },
    bindDevice(){
      var formData = new FormData();
      formData.append("firstDeviceId",this.deviceId);
      this.$server
        .exam("/customer/apartment/getGatewayChildrenDevice", formData)
        .then(data => {
          if (data.code == 200) {
            this.bindDeviceData = data.data;
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },
    getGatewayDeviceList(roomData){
        var deviceList=roomData.deviceList;
        var rtn="";
        if(deviceList.length>0&&deviceList!=""){
          for(var str in deviceList){
            rtn+=deviceList[str].deviceName+",";
          }
          rtn=rtn.substring(0,rtn.length-1);
        }  
        return rtn
    },
    alarmPower() {
      var formData = new FormData();
      formData.append("deviceId", this.deviceId);
      formData.append("pageNo", this.alarmPageData.offset);
      formData.append("pageSize", this.alarmPageData.pageNumber);
      this.$server
        .exam("/customer/apartment/listDeviceAlarmRecord", formData)
        .then(data => {
          if (data.code == 200) {
            this.alarmPageData = data.data.records;
            this.total = data.data.total;
            // this.oAssEquipmentDto.offset = 1;
            // this.oAssEquipmentDto.pageNumber = data.data.pages;
          } else {
            this.$message({
              message: data.message,
              type: "warning"
            });
          }
        });
    },

    alarmHandleSizeChange(val) {
      this.alarmPageData.pageNumber = val;
      this.alarmPower();
    },
    alarmHandleCurrentChange(val) {
      this.alarmPageData.offset = val;
      this.alarmPower();
    },
  },
  components: {
    Pagings
  },
};
</script>


// WEBPACK FOOTER //
// src/components/device/gatewayDetail.vue